import { render, staticRenderFns } from "./LevelOther.vue?vue&type=template&id=028ad452&scoped=true"
import script from "./LevelOther.vue?vue&type=script&lang=js"
export * from "./LevelOther.vue?vue&type=script&lang=js"
import style0 from "./LevelOther.vue?vue&type=style&index=0&id=028ad452&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028ad452",
  null
  
)

export default component.exports